// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import Component from "@/routes/company/_layout/inventory/available-inventory/-components/component";
import { createFileRoute } from "@tanstack/react-router";
import { SearchParams } from "./-data/model";

export const Route = createFileRoute("/company/_layout/inventory/available-inventory/")({
    component: Component,
    validateSearch: SearchParams,
});